var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "#1F72CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1593 14.1666L4.85742 26.2445H11.2045L11.9913 24.3188H13.7899L14.5767 26.2445H21.5631V24.7748L22.1856 26.2445H25.7995L26.422 24.7437V26.2445H40.9517L42.7184 24.3688L44.3727 26.2445L51.8355 26.2601L46.5169 20.2393L51.8355 14.1666H44.4885L42.7686 16.0077L41.1664 14.1666H25.3601L24.0028 17.284L22.6136 14.1666H16.2798V15.5864L15.5752 14.1666H10.1593ZM11.3874 15.8817H14.4812L17.998 24.0718V15.8817H21.3872L24.1034 21.754L26.6068 15.8817H29.979V24.5484H27.9271L27.9103 17.7572L24.9188 24.5484H23.0832L20.0749 17.7572V24.5484H15.8536L15.0533 22.6054H10.7297L9.9311 24.5467H7.66936L11.3874 15.8817ZM40.2 15.8817H31.8563V24.5433H40.0708L42.7184 21.6727L45.2703 24.5433H47.938L44.0606 20.2376L47.938 15.8817H45.3861L42.7519 18.7193L40.2 15.8817ZM12.8924 17.3481L11.468 20.8093H14.3153L12.8924 17.3481ZM33.9168 19.2582V17.6761V17.6746H39.1229L41.3946 20.2048L39.0223 22.7488H33.9168V21.0216H38.4686V19.2582H33.9168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.e039f6c9372a3506a77a8cb78d55c54f.svg";
export { ForwardRef as ReactComponent };